// extracted by mini-css-extract-plugin
export default {"subscriptionTable":"qzLxyB6vCW8DHHN4abLv"};